var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconChevronUp = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M8.03025 14.0303C7.73775 14.3228 7.26225 14.3228 6.96975 14.0303C6.67725 13.7378 6.6765 13.2623 6.96975 12.9698L11.4697 8.46976C11.7622 8.17726 12.2377 8.17726 12.5302 8.46976L17.0302 12.9698C17.3227 13.2623 17.3227 13.7378 17.0302 14.0303C16.7377 14.3228 16.2622 14.3228 15.9697 14.0303L12 10.0605L8.03025 14.0303Z", fill: "black" }))),
        alt: 'Icon ChevronUp',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconChevronUp;
//# sourceMappingURL=index.js.map